import { REMOVE_GROCERYLIST_LIMIT_NOTIFICATION } from './actionTypes';

export default () => ({
  type: REMOVE_GROCERYLIST_LIMIT_NOTIFICATION,
});